import { FileImageOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import React, { memo, useRef } from 'react'
import { Transforms } from 'slate'
import { useSlate } from 'slate-react'

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

const ImageBtn = memo(() => {
  const fileInput = useRef<HTMLInputElement>(null)
  const editor = useSlate()

  const onUploadFile = (e) => {
    const file = e.target.files[0]
    if (file) {
      toBase64(file).then((dataUrl) => {
        const text = { text: '' }
        const image = [
          { type: 'image', url: dataUrl, children: [text] },
          {
            type: 'paragraph',
            children: [text]
          }
        ]
        Transforms.insertNodes(editor, image)
        Transforms.move(editor)
      })
    }
  }

  return (
    <button
      type='button'
      className={classNames('icon-btn')}
      onMouseDown={(event) => {
        event.preventDefault()
      }}
    >
      <FileImageOutlined onClick={() => fileInput?.current?.click()} />
      <input type='file' onChange={onUploadFile} style={{ display: 'none' }} ref={fileInput} accept='image/*' />
    </button>
  )
})

export default ImageBtn
